import clone from "clone";
import React, { useState } from "react";
import { usePopper } from "react-popper";
import { Button } from "../button/Button";
import styled from "styled-components";
import { AmorgMenu } from "./AmorgMenu";
import { AmorgMenuContent } from "./AmorgMenuTypes";
import { iconName } from "../icons/Icons";
import { colors } from "../colors/color";

export type AmorgMenuButtonProps = {
    content:AmorgMenuContent[],
    zIndex?:number,
    icon?:iconName
}
export function AmorgMenuButton(props:AmorgMenuButtonProps): JSX.Element {
    const [show, setShow] = useState(false);

    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const [arrowElement, setArrowElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        modifiers: [
            { name: 'arrow', options: { element: arrowElement } }],
        placement:'bottom-end'
    });

    const [modifiedProps, setModifiedProps] = React.useState(null)
    React.useEffect(()=>{
        const clonedItems = clone(props.content);
        for(let i=0; i<clonedItems.length; i++){
            
            const itm = clonedItems[i];
            if(itm.type === 'leadingContent' || itm.type === 'trailingContent' || itm.type === 'leadingTrailingContent'){
                if(itm.onClick !== undefined){
                    const func = itm.onClick;
                    itm.onClick = () => {
                        setShow(false);
                        func();
                    }
                }
            }
        }
        setModifiedProps(clonedItems);
    }, [props.content]);

    const buttonRef = React.useRef(null);

    return (
        <>
            <span ref={setReferenceElement}>
                <Button innerRef={buttonRef} variant="text" icon={props.icon || "navigation_context"}
                    onClick={() => {
                        setShow(!show)
                    }
             } />
            </span>

            {modifiedProps && show && 
                <div ref={setPopperElement} style={{...styles.popper, zIndex:100000000}} {...attributes.popper} >
                    <MenuContainer>
                        <AmorgMenu
                            content={modifiedProps} 
                            onClickOutside={(event)=>{
                                if(buttonRef.current && buttonRef.current.contains(event.target))
                                    // button was clicked. Will be handled by handler. Return to avoid calling twice
                                    return;
                                else
                                    setShow(false);
                            }}
                        />
                    </MenuContainer>
                    <div ref={setArrowElement} style={styles.arrow} />
                </div>
            }
        </>
    );
}

const MenuContainer = styled.div`  
    border-radius: 4px;   
    background-color: ${colors.menu.background};
    border: 1px solid ${colors.menu.border};
    & button{
        white-space: nowrap;
    }
`;
